import React, { useEffect, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import {
  FavoriteModal,
  Menu,
  NotificationContainer,
  RemoveBookingSchedulerModal,
  RemoveFavoriteModal
} from './containers'
import { routes, urls } from './routing'
import { Application } from './config'
import literalsService from './services/literals-service'
import { appsGeneralInfoSelected, appsStyleSelected, appsURLSSelected } from './helpers/app'
import { loadGoogleMaps } from './helpers/maps'
import TownsModal from './containers/TownsModal'
import QrModal from './containers/QrModal'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { useDispatch, useSelector } from 'react-redux'
import { IStoreState } from './store/states'
import { setStripeAction } from './store/actions'
import AlterationModal from './containers/AlterationModal'
import FeedbackModal from './containers/FeedbackModal'
import SingleStopModal from './containers/NewReservation/SingleStopModal'

function App() {

  const { isAmb, isIframe } = Application

  const userInfo = useSelector((state: IStoreState) => state.userInfo)
  const [stripeAccountId, setStripeAccountId] = useState(userInfo.accountId)

  const dispatch = useDispatch()

  const fetchStripePromise = async (accountId: string) => {
    const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY
    if (stripeKey) {
      let loadStripeOptions = {}
      if (accountId) {
        loadStripeOptions = {
          stripeAccount: accountId
        }
      }
      const stripePromise = await loadStripe(
        stripeKey,
        loadStripeOptions
      )
      dispatch(setStripeAction(stripePromise!))
      return stripePromise
    }
    return null
  }

  useEffect(() => {
    if (userInfo.accountId !== stripeAccountId) setStripeAccountId(userInfo.accountId)
  }, [userInfo.accountId])

  useEffect(() => {
    if (!isIframe) loadGoogleMaps()
  }, [])

  const showMenu = (route: any) => {
    if (isIframe) {
      const reservationFlowUrls = [
        urls.newReservationBusStopsStep,
        urls.newReservationDateStep,
        urls.newReservationRouteOptionsStep,
        urls.newReservationConfirmationStep
      ]
      const routeUrls = Array.isArray(route.url) ? route.url : [route.url]
      const isReservationFlow = routeUrls.some((u: string) => reservationFlowUrls.includes(u))
      return route.isAuthenticated && !isReservationFlow
    } else {
      return route.isAuthenticated
    }
  }

  const pages = routes.flatMap((route: any, i: number) => {
    const urls = Array.isArray(route.url) ? route.url : [route.url]
    return urls.map((url: string, j: number) => (
      <Route key={`${i}-${j}`} path={url} element={
        <>
          {showMenu(route) ? <Menu /> : null}
          <route.content />
        </>
      } />
    ))
  })

  const main = document.getElementById('nemi-amb-web')
  if(main) main.style.height = isAmb ? '' : '100%'

  const stripeOptions: StripeElementsOptions = {
    mode: 'payment',
    amount: 1,
    currency: 'eur'
  }

  return (
    <Elements stripe={ fetchStripePromise(stripeAccountId) } options={ stripeOptions } key={stripeAccountId}>
      <div id="quickAccess">
        <strong>Accessos directes:</strong>
        <ul>
          <li>
            <a
              title="V&eacute;s al contingut. (Tecla d'acc&egrave;s: 1)"
              href="#main-content"
              accessKey="1"
            >
              [1] Contingut &raquo;
            </a>
          </li>
          <li>
            <a
              title="V&eacute;s al cercador principal. (Tecla d'acc&egrave;s: 2)"
              href="#quickSearch"
              accessKey="3"
            >
              [3] Cercador
            </a>
          </li>
        </ul>
      </div>
      <div id="wrapper" className={ appsStyleSelected?.style }>
        <header className={ isAmb ? 'coorp' : 'nodisplayed' }>
          <div className="module-grid">
            <div
              className="menu"
              itemScope
              itemType="http://schema.org/Organization"
            >
              <h1>
                <a
                  id={ appsGeneralInfoSelected?.id }
                  itemProp="url"
                  href={ appsURLSSelected?.home }
                  target="_blank"
                  rel="noreferrer"
                  title={ appsGeneralInfoSelected?.title }
                >
                  <span className="nojs" itemProp="name">
                    { appsGeneralInfoSelected?.title }
                  </span>
                </a>
              </h1>
            </div>
            <ul className="list menu inline eines onright">
              <li>
                <a
                  href="#tool-search"
                  role="button"
                  className={ isAmb ? 'icon icon-search' : 'nodisplayed' }
                  data-menu="tool-search"
                >
                  Buscar
                </a>
              </li>
              <li>
                <a
                  href="#tool-share"
                  role="button"
                  className="icon icon-share"
                  data-menu="tool-share"
                >
                  Compartir
                </a>
              </li>
            </ul>
          </div>
        </header>
        <div className={ `header-menu menu-tools ${isAmb ? 'coorp' : 'nodisplayed'}` } id="tool-search">
          <section className="row search" data-menu="tool-search">
            <div className="module-grid">
              <a
                href="#tool-search"
                aria-labelledby="tool-search"
                className="closemenu"
              >
                <span className="icon close">Tancar menu</span>
              </a>
              <form
                id="quickSearch"
                action="https://www.amb.cat/web/cercador"
                method="get"
              >
                <fieldset>
                  <legend>{'Cercador global de l\'AMB'}</legend>
                  <label htmlFor="queryText" className="visuallyhidden">
                    {'Cercador global de l\'AMB'}
                  </label>
                  <input
                    name="query"
                    id="queryText"
                    type="search"
                    placeholder={literalsService.get('search', true)}
                  />

                  <input
                    type="hidden"
                    name="p_p_id"
                    value="GCSRESTPortlet_WAR_RESTportlet_INSTANCE_f5zOH5pHoY1D"
                  />
                  <input type="hidden" name="p_p_lifecycle" value="1" />
                  <input type="hidden" name="p_p_state" value="normal" />
                  <input type="hidden" name="p_p_mode" value="view" />
                  <input type="hidden" name="p_p_col_id" value="column-2" />
                  <input type="hidden" name="p_p_col_count" value="2" />
                  <input
                    type="hidden"
                    name="defaultSearchConfiguration"
                    value="true"
                  />
                  <label htmlFor="amb_global_search" className="visuallyhidden">
                    Cerca
                  </label>
                  <input type="submit" value="Cerca" id="amb_global_search" />
                </fieldset>
              </form>
            </div>
          </section>
        </div>
        <div className={ `header-menu menu-tools ${isAmb ? 'coorp' : 'nodisplayed'}` } id="tool-share">
          <section className="row compartir" data-menu="tool-share">
            <div className="module-grid">
              <a
                href="#tool-share"
                aria-labelledby="tool-share"
                className="closemenu"
              >
                <span className="icon close">Tancar menu</span>
              </a>
              <div className="list view-grid columned columned-4">
                <div className="block">
                  <ul className="list block">
                    <li className={ isAmb ? '' : 'nodisplayed'}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="//www.facebook.com/share.php?u=http://www.amb.cat/guia-estils"
                        className="icon xarxes fb"
                        data-ga="click"
                        data-ga-action="Xarxa social"
                        title="Compartir a facebook"
                      >
                        Facebook
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="block">
                  <ul className="list block">
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={ appsURLSSelected?.twitter }
                        className="icon xarxes tw"
                        data-ga="click"
                        data-ga-action="Xarxa social"
                        title="Compartir a twitter"
                      >
                        Twitter
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="block">
                  <ul className="list block">
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={ appsURLSSelected?.linkedin }
                        className="icon xarxes ld"
                        data-ga="click"
                        data-ga-action="Xarxa social"
                        title="Compartir a LinkedIn"
                      >
                        LinkedIn
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="block hide-ios">
                  <ul className="list block">
                    <li className="">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://api.whatsapp.com/send?text=http://www.amb.cat/guia-estils"
                        data-action="share/whatsapp/share"
                        className="icon xarxes wa"
                        data-ga="click"
                        data-ga-action="Xarxa social"
                        title="Compartir a WhatsApp"
                      >
                        WhatsApp
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className={ isAmb ? 'app__content' : appsStyleSelected?.style }>
          <Routes>
            { pages }
          </Routes>
          <NotificationContainer />
          <FavoriteModal />
          <RemoveFavoriteModal />
          <RemoveBookingSchedulerModal />
          <TownsModal />
          <QrModal />
          <AlterationModal />
          <FeedbackModal />
          <SingleStopModal />
        </section>
        <footer className={ isAmb ? '' : 'nodisplayed' }>
          <nav className="coorp amb">
            <ul className="list inline onleft">
              <li>
                <h6 className="logo">
                  <a
                    title={ appsGeneralInfoSelected?.title }
                    target="blank_"
                    className={ appsStyleSelected?.style}
                    href={ appsURLSSelected?.home }
                  >
                    { appsGeneralInfoSelected?.title }
                  </a>
                </h6>
              </li>
              <li>
                <span className="logo feder"></span>
              </li>
            </ul>
            <ul className="list inline onright">
              <li>
                <a
                  className={ isAmb ? '' : 'nodisplayed' }
                  title={ literalsService.get('howToArrive' ,true) }
                  href="http://www.amb.cat/s/web/amb/com-arribar.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  { literalsService.get('howToArrive' ,true) }
                </a>
              </li>
              <li>
                <a
                  title={ literalsService.get('contact' ,true) }
                  target="_blank"
                  rel="noreferrer"
                  href={ appsURLSSelected?.contact }
                >
                  { literalsService.get('contact' ,true) }
                </a>
              </li>
              <li>
                <a
                  title={ literalsService.get('accessibility', true) }
                  target="_blank"
                  rel="noreferrer"
                  href="http://www.amb.cat/s/web/amb/accessibilitat.html"
                >
                  { literalsService.get('accessibility', true) }
                </a>
              </li>
              <li>
                <a
                  title={ literalsService.get('legalNotice', true) }
                  target="_blank"
                  rel="noreferrer"
                  href="http://www.amb.cat/s/web/amb/avis-legal.html"
                >
                  { literalsService.get('legalNotice', true) }
                </a>
              </li>
              <li className="block">
                <a
                  href="http://www.amb.cat/s/web/amb/politica-de-privacitat.html"
                  target="_blank"
                  rel="noreferrer"
                  title={ literalsService.get('privacyPolicy', true) }
                >
                  { literalsService.get('privacyPolicy', true) }
                </a>
              </li>
              <li>
                <a
                  title={ literalsService.get('awardsMentions', true) }
                  target="_blank"
                  rel="noreferrer"
                  href="http://www.amb.cat/web/amb/premis-i-mencions"
                >
                  { literalsService.get('awardsMentions', true) }
                </a>
              </li>
              <li>
                <a
                  title={ appsGeneralInfoSelected?.copyright }
                  href={ appsURLSSelected?.home }
                  target="_blank"
                  rel="noreferrer"
                >
                  { appsGeneralInfoSelected?.copyright }
                </a>
              </li>
            </ul>
          </nav>
        </footer>
      </div>
    </Elements>
  )
}

export default App
